/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { hasClass } from '@/js/utils/css'
import { findAllSelf } from '@/js/utils/dom'

const SELECTOR = 'input.form-control,select.form-select,textarea.form-control'

/** Inputs whose change handler is already bound, so we never bind it twice. */
const boundInputs = new WeakSet()

/**
 * Toggle the `.is-invalid` class on required inputs from their `change` event
 * only — so errors appear once the field loses focus (or a value is picked),
 * never on load, and clear as soon as a valid value is entered.
 *
 * @type {Listener}
 */
export default {
    selector: SELECTOR,
    connect(element) {
        handleRequiredFields(element)
    },
}

/**
 * Bind the change handler on every matching field within `container` (and on
 * `container` itself when it matches). Also called directly by eforms pages
 * after they swap form fragments outside the mount lifecycle.
 */
export function handleRequiredFields(container = document) {
    findAllSelf(SELECTOR, container).forEach((item) => {
        if (boundInputs.has(item)) {
            return
        }
        boundInputs.add(item)
        item.addEventListener('change', () => updateItemState(item))
    })
}

function updateItemState(item) {
    const isRequired = item.hasAttribute('required')
    const isReadonly = item.hasAttribute('readonly')
    const isDisabled = item.hasAttribute('disabled')
    const isEmpty = item.value.length === 0
    const isInvalid = isRequired && !isDisabled && !isReadonly && isEmpty

    item.classList.toggle('is-invalid', isInvalid)

    const parent = item.parentElement
    if (parent && hasClass(parent, 'dropdown')) {
        parent.classList.toggle('is-invalid', isInvalid)
    }
}
